<div class="col-xs-12 col-sm-9">
    <div class="jumbotron">
        <h1>{{translate.instant("PAGENOTFOUNDTITRE")}}</h1>
        <p>{{translate.instant("PAGENOTFOUNDMESS")}}</p>
    </div>
</div>
